import { render, staticRenderFns } from "./alertEmailConfigure.vue?vue&type=template&id=c51a96e8&scoped=true&"
import script from "./alertEmailConfigure.vue?vue&type=script&lang=js&"
export * from "./alertEmailConfigure.vue?vue&type=script&lang=js&"
import style0 from "./alertEmailConfigure.vue?vue&type=style&index=0&id=c51a96e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c51a96e8",
  null
  
)

export default component.exports